// ----------------------------------------------------------------------------
// Component: Video Block
// ----------------------------------------------------------------------------
//
// Content component that positions a video in a custom-sized block, or in
// the flex-position or flex-grid.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/video-player/video-block';

// Styles
import './_video-block.scss';

// -------------------------------------
// Video Block Section
// -------------------------------------

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll('.video-block--section').forEach((videoBlock) => {
    const videoBlockMobile = videoBlock.querySelector('.video-block--mobile');
    const videoBlockDesktop = videoBlock.querySelector('.video-block--desktop');

    if (videoBlockMobile) {
        const mobilePlayButton = videoBlockMobile.querySelector('.video-block__play-button');
        const mobileVideo = videoBlockMobile.querySelector('.video-block__video');

        mobilePlayButton.addEventListener('click', function() {
            mobileVideo.play();
            videoBlockMobile.classList.add('video-block--playing');
        });
    }

    if (videoBlockDesktop) {
        const desktopPlayButton = videoBlockDesktop.querySelector('.video-block__play-button');
        const desktopVideo = videoBlockDesktop.querySelector('.video-block__video');

        desktopPlayButton.addEventListener('click', function() {
            desktopVideo.play();
            videoBlockDesktop.classList.add('video-block--playing');
        });
    }
});
